import { apiService as api } from './api';
import { Motorista, Veiculo, Abastecimento, Viagem, ApiResponse, Paginacao } from '../types';

export interface MotoristasFilters {
  status?: string;
  categoria_cnh?: string;
  cidade?: string;
  search?: string;
  sort_by?: string;
  sort_order?: string;
  per_page?: number;
  page?: number;
}

export interface MotoristasResponse {
  success: boolean;
  data: Motorista[];
  message?: string;
  pagination: Paginacao;
}

export interface MotoristaResponse {
  success: boolean;
  data: Motorista;
  message?: string;
  estatisticas?: any;
}

export interface DeleteResponse {
  success: boolean;
  message: string;
}

export const motoristasService = {
  // Listar motoristas com filtros
  getMotoristas: async (filters: MotoristasFilters = {}): Promise<MotoristasResponse> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<MotoristasResponse>(`/v1/motoristas?${params.toString()}`);
    return response;
  },

  // Buscar motorista por ID
  getMotorista: async (id: number): Promise<MotoristaResponse> => {
    const response = await api.get<MotoristaResponse>(`/v1/motoristas/${id}`);
    return response;
  },

  // Criar novo motorista
  createMotorista: async (motorista: Partial<Motorista>): Promise<MotoristaResponse> => {
    const response = await api.post<MotoristaResponse>('/v1/motoristas', motorista);
    return response;
  },

  // Atualizar motorista
  updateMotorista: async (id: number, motorista: Partial<Motorista>): Promise<MotoristaResponse> => {
    const response = await api.put<MotoristaResponse>(`/v1/motoristas/${id}`, motorista);
    return response;
  },

  // Excluir motorista
  deleteMotorista: async (id: number): Promise<DeleteResponse> => {
    const response = await api.delete<DeleteResponse>(`/v1/motoristas/${id}`);
    return response;
  },

  // Listar veículos do motorista
  getVeiculos: async (motoristaId: number, page: number = 1): Promise<ApiResponse<Veiculo[]>> => {
    const response = await api.get<ApiResponse<Veiculo[]>>(`/v1/motoristas/${motoristaId}/veiculos?page=${page}`);
    return response;
  },

  // Listar abastecimentos do motorista
  getAbastecimentos: async (motoristaId: number, filters: any = {}): Promise<ApiResponse<Abastecimento[]>> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ApiResponse<Abastecimento[]>>(`/v1/motoristas/${motoristaId}/abastecimentos?${params.toString()}`);
    return response;
  },

  // Listar viagens do motorista
  getViagens: async (motoristaId: number, filters: any = {}): Promise<ApiResponse<Viagem[]>> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ApiResponse<Viagem[]>>(`/v1/motoristas/${motoristaId}/viagens?${params.toString()}`);
    return response;
  },

  // Calcular desempenho do motorista
  getDesempenho: async (motoristaId: number): Promise<ApiResponse<any>> => {
    const response = await api.get<ApiResponse<any>>(`/v1/motoristas/${motoristaId}/desempenho`);
    return response;
  },

  // Listar CNHs próximas do vencimento
  getCnhVencimentos: async (dias: number = 30): Promise<ApiResponse<Motorista[]>> => {
    const response = await api.get<ApiResponse<Motorista[]>>(`/v1/motoristas/cnh/vencimentos?dias=${dias}`);
    return response;
  },
};
